import { useAuth0 } from '@/utils/auth/auth0'
import { Unauthenticated, Authenticated } from '../utils/auth/auth.tsx'
import { Button } from '@mui/material'
import { setPostLoginRedirect } from '@/utils/postLoginRedirect'
import { clearDatabaseSearchStorage } from '@/utils/databaseSearchSession'

function setPostLoginRedirectIfOnInvitePage() {
  const currentPath = window.location.pathname
  if (currentPath.startsWith('/invite')) {
    setPostLoginRedirect(currentPath)
  }
}

// Shared login/signup redirect handlers so the standard buttons and the
// invite-specific prompt trigger Auth0 identically (and preserve the
// post-login redirect, which stores pathname only — no ?action leaks in).
export function useAuthRedirect() {
  const { loginWithRedirect } = useAuth0()

  const login = () => {
    setPostLoginRedirectIfOnInvitePage()
    loginWithRedirect({ prompt: 'select_account' })
  }

  const signup = () => {
    setPostLoginRedirectIfOnInvitePage()
    loginWithRedirect({ screen_hint: 'signup', prompt: 'select_account' })
  }

  return { login, signup }
}

export function LoginButton() {
  const { login: handleLogin } = useAuthRedirect()

  return (
    <>
      <Unauthenticated>
        <Button
          disableRipple
          variant="contained"
          sx={{
            borderRadius: 3,
            bgcolor: '#1C3045',
            color: 'white',
            m: 0.5,
            width: '50%',
            fontSize: '22px',
            textTransform: 'none',
          }}
          onClick={handleLogin}
        >
          Login
        </Button>
      </Unauthenticated>
    </>
  )
}
export function SignupButton() {
  const { signup: handleSignup } = useAuthRedirect()

  return (
    <>
      <Unauthenticated>
        <Button
          disableRipple
          variant="outlined"
          sx={{
            borderRadius: 3,
            borderColor: '#1C3045',
            border: 2,
            bgcolor: 'white',
            color: '#1C3045',
            m: 0.5,
            width: '50%',
            fontSize: '22px',
            textTransform: 'none',
            '&:focus': {
              backgroundColor: '#e8e8e8',
            },
          }}
          onClick={handleSignup}
        >
          Sign Up
        </Button>
      </Unauthenticated>
    </>
  )
}
export function LogoutButton() {
  const { logout } = useAuth0()

  const handleLogout = () => {
    localStorage.removeItem('onboarding_exited')
    clearDatabaseSearchStorage()
    logout({ returnTo: window.location.origin })
  }

  return (
    <>
      <Authenticated>
        <Button
          disableRipple
          onClick={handleLogout}
          variant="contained"
          sx={{
            borderRadius: 3,
            bgcolor: '#1C3045',
            color: 'white',
            my: 0.5,
            mx: 1,
            px: 4,
            fontSize: '16px',
            textTransform: 'none',
            boxShadow: 'none',
          }}
        >
          Logout
        </Button>
      </Authenticated>
    </>
  )
}
